import type { MenuItem } from "@/layouts/default-layout/config/types";
import { PermissonEnum, ModuleEnum } from "~/constants/newsEnum";
const MainMenuConfig: Array<MenuItem> = [
  {
    pages: [
      {
        heading: "Trang tổng quan",
        route: "/",
        keenthemesIcon: "element-11",
        bootstrapIcon: "bi-app-indicator",
      },
      {
          heading: "Hồ sơ bảo lãnh",
          route: "/documents",
          keenthemesIcon: "document",
        bootstrapIcon: "bi-layers",
      },
    ],
  },
  //{
  //  heading: "Hệ thống",
  //  route: "/apps",
  //  pages: [
  //    {
  //      sectionTitle: "Tài khoản",
  //      route: "/customers",
  //      keenthemesIcon: "profile-user",
  //      bootstrapIcon: "bi-printer",
  //      sub: [
  //        {
  //          heading: "Danh sách tài khoản",
  //          route: "/account",
  //          module: ModuleEnum.User,
  //        },
  //        {
  //          heading: "Nhóm tài khoản",
  //          route: "/role",
  //          module: ModuleEnum.Role,
  //        },
  //      ],
  //    },
  //    {
  //      sectionTitle: "Quản lý danh mục",
  //        route: "/zone",
  //      keenthemesIcon: "category",
  //      bootstrapIcon: "bi-printer",
  //      sub: [
  //        {
  //          heading: "Dòng sự kiện",
  //              route: "/zone",
  //          module: ModuleEnum.Thread,
  //        },
  //        {
  //          heading: "Chủ đề",
  //            route: "/zone",
  //          module: ModuleEnum.Topic,
  //        },
  //        {
  //          heading: "Từ khóa - Tags",
  //            route: "/zone",
  //          module: ModuleEnum.Tag,
  //        },
  //      ],
  //    },
  //  ],
  //},
];

export default MainMenuConfig;

export function getAllChildModule() {
  const { $isPermissionModule } = useNuxtApp();
  let allChildModule: Array<MenuItem> = [];
  MainMenuConfig.forEach((item) => {
    if (item.pages) {
      item.pages.forEach((page) => {
        if (page.sub) {
          allChildModule = allChildModule.concat((page.sub ?? []).filter(
            (c) => !c.module || $isPermissionModule(c.module, PermissonEnum.Allow)
          ));
        }
      });
    }
    if (item.sub) {
      allChildModule = allChildModule.concat(
        (item.sub ?? []).filter(
          (c) => !c.module || $isPermissionModule(c.module, PermissonEnum.Allow)
        )
      );
    }
    if (!item.pages && !item.sub) {
      allChildModule.push(item);
    }
  });

  return allChildModule;
}
